import { render, staticRenderFns } from "./FormBasic.vue?vue&type=template&id=0b54f2a7&scoped=true&"
import script from "./FormBasic.vue?vue&type=script&lang=ts&"
export * from "./FormBasic.vue?vue&type=script&lang=ts&"
import style0 from "./FormBasic.vue?vue&type=style&index=0&id=0b54f2a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b54f2a7",
  null
  
)

export default component.exports